import { getCookie } from './app-utils';
import { util } from './miaw/common';

/** REQUEST_ID OPERTAIONS  */
const CHATBOT_REST_ID = 'CHATBOT_REST_ID';
const CHATBOT_REST_COUNTER = 'CHATBOT_REST_COUNTER';
export const getRestId = (increaseCounter = true) => {
  if (typeof window === 'undefined') return '';
  setRestId();
  const id = window?.localStorage?.getItem(CHATBOT_REST_ID) || '';
  const numberId = window?.localStorage?.getItem(CHATBOT_REST_COUNTER);
  let restCounter = Number(numberId);
  if (increaseCounter) {
    restCounter += 1;
    // Save the incremented counter back to local storage
    window?.localStorage?.setItem(CHATBOT_REST_COUNTER, restCounter.toString());
  }
  return `${id}_${restCounter}`;
};
export const getRestIdWithoutCounter = () => {
  if (typeof window === 'undefined') return '';
  setRestId();
  const id = window?.localStorage?.getItem(CHATBOT_REST_ID) || '';
  console.log('Rest ID without counter:', id);
  return id;
};

export const setRestId = () => {
  if (typeof window === 'undefined') return;

  let id = window?.localStorage?.getItem(CHATBOT_REST_ID) || '';
  if (!id) {
    id = util.generateUUID();
  }

  let restCounter = Number(localStorage.getItem(CHATBOT_REST_COUNTER));
  if (isNaN(Number(restCounter))) {
    restCounter = 1;
  }
  window?.localStorage?.setItem(CHATBOT_REST_ID, id);
  window?.localStorage?.setItem('CHATBOT_REST_COUNTER', restCounter.toString());
};

export const clearRestId = () => {
  if (typeof window === 'undefined') return;

  window?.localStorage?.removeItem(CHATBOT_REST_ID);
  window?.localStorage?.removeItem(CHATBOT_REST_COUNTER);
};

/** CHATBOT TOKEN OPERATIONS */

const CHATBOT_TOKEN_KEY = 'chatbotToken';

export const setChatbotToken = (token: string, isSignedIn: boolean) => {
  if (typeof window === 'undefined') return;

  window?.localStorage?.setItem(CHATBOT_TOKEN_KEY, token);
  setIsUserLoggedInAtChatStart(isSignedIn);
};
export const getChatbotToken = () => {
  if (typeof window === 'undefined') {
    console.warn('Chatbot token not found in local storage.');
    return '';
  }

  const token = window?.localStorage?.getItem(CHATBOT_TOKEN_KEY);
  if (!token) {
    console.warn('Chatbot token not found in local storage.');
  }
  return token;
};

export const clearChatbotToken = () => {
  if (typeof window === 'undefined') return;
  window?.localStorage?.removeItem(CHATBOT_TOKEN_KEY);
  clearIsUserLoggedInAtChatStart();
};

/** user logged in status at chat start */

export const setIsUserLoggedInAtChatStart = (isLoggedIn: boolean) => {
  if (typeof window === 'undefined') return;
  window?.localStorage?.setItem('CHAT_USER_LOGGED_IN', JSON.stringify(isLoggedIn));
};

export const getIsUserLoggedInAtChatStart = () => {
  if (typeof window === 'undefined') return 'false';

  const value = window?.localStorage?.getItem('CHAT_USER_LOGGED_IN');

  return value || 'false';
};

export const clearIsUserLoggedInAtChatStart = () => {
  if (typeof window === 'undefined') return;
  window?.localStorage?.removeItem('CHAT_USER_LOGGED_IN');
};
/** CHAT SESSION OPERATIONS */
const CHAT_SESSION_KEY = 'chatSession';

export const getChatSessionType = () => {
  if (typeof window === 'undefined') return 'initial';
  const chatSession = window?.localStorage?.getItem(CHAT_SESSION_KEY);
  if (chatSession === 'miawChatSession' || chatSession === 'chatbotSession') {
    return chatSession;
  }
  return 'initial';
};

export const setChatSessionType = (sessionType: 'initial' | 'miawChatSession' | 'chatbotSession') => {
  if (typeof window === 'undefined') return;
  window?.localStorage?.setItem(CHAT_SESSION_KEY, sessionType);
};

export const clearChatSessionType = () => {
  if (typeof window === 'undefined') return;
  window?.localStorage?.removeItem(CHAT_SESSION_KEY);
};

const CHAT_WINDOW_STATE_KEY = 'chatWindowState';

export const setChatWindowState = (state: 'minimized' | 'maximized' | 'hidden') => {
  if (typeof window === 'undefined') return;
  window?.localStorage?.setItem(CHAT_WINDOW_STATE_KEY, state);
};

export const getChatWindowState = () => {
  if (typeof window === 'undefined') return 'minimized';
  const state = window?.localStorage?.getItem(CHAT_WINDOW_STATE_KEY);
  return state === 'maximized' ? 'maximized' : state === 'hidden' ? 'hidden' : 'minimized';
};

export const clearChatWindowState = () => {
  if (typeof window === 'undefined') return;
  window?.localStorage?.removeItem(CHAT_WINDOW_STATE_KEY);
};

export const setPreChatInfoLocalStorage = (userInfo: { firstName: string; lastName: string; email: string }) => {
  if (typeof window === 'undefined') return;

  window?.localStorage?.setItem('MIAW_PRE_CHAT_USER_INFO', JSON.stringify(userInfo));
};

export const getPreChatInfoFromLocalStorage = () => {
  if (typeof window === 'undefined') return null;

  const userInfo = window?.localStorage?.getItem('MIAW_PRE_CHAT_USER_INFO');
  const userObject = userInfo ? JSON.parse(userInfo) : null;
  return userObject;
};

export const clearPreChatInfoFromLocalStorage = () => {
  if (typeof window === 'undefined') return;

  window?.localStorage?.removeItem('MIAW_PRE_CHAT_USER_INFO');
};

export const setIsSendRoutingAttributes = (value: boolean) => {
  if (typeof window === 'undefined') return;

  window?.localStorage?.setItem('MIAW_SEND_ROUTING_ATTRIBUTES', JSON.stringify(value));
};

export const getIsSendRoutingAttributes = () => {
  if (typeof window === 'undefined') return false;

  const value = window?.localStorage?.getItem('MIAW_SEND_ROUTING_ATTRIBUTES');
  const parsedValue = value ? value === 'true' : false;
  return parsedValue;
};

export const clearIsSendRoutingAttributes = () => {
  if (typeof window === 'undefined') return;

  window?.localStorage?.removeItem('MIAW_SEND_ROUTING_ATTRIBUTES');
};

export const setUnreadCount = (count: number) => {
  if (typeof window === 'undefined') return;

  window?.localStorage?.setItem('CHAT_UNREAD_COUNT', count.toString());
};

export const getUnreadCount = () => {
  if (typeof window === 'undefined') return 0;

  const count = window?.localStorage?.getItem('CHAT_UNREAD_COUNT');
  return count ? Number(count) : 0;
};

export const clearUnreadCount = () => {
  if (typeof window === 'undefined') return;

  window?.localStorage?.removeItem('CHAT_UNREAD_COUNT');
};

export const setOrderNumberForChatbot = (orderNumber: string) => {
  if (typeof window === 'undefined') return;

  window?.localStorage?.setItem('CHATBOT_ORDER_NUMBER', orderNumber);
};

export const getOrderNumberForChatbot = () => {
  if (typeof window === 'undefined') return '';

  const orderNumber = window?.localStorage?.getItem('CHATBOT_ORDER_NUMBER');
  return orderNumber || '';
};

export const clearOrderNumberForChatbot = () => {
  if (typeof window === 'undefined') return;

  window?.localStorage?.removeItem('CHATBOT_ORDER_NUMBER');
};

export const setSelectedProductIdsForChatbot = (productIds: string[]) => {
  if (typeof window === 'undefined') return;

  window?.localStorage?.setItem('CHATBOT_SELECTED_PRODUCT_IDS', JSON.stringify(productIds));
};

export const getSelectedProductIdsForChatbot = () => {
  if (typeof window === 'undefined') return [];

  const productIds = window?.localStorage?.getItem('CHATBOT_SELECTED_PRODUCT_IDS');
  return productIds ? JSON.parse(productIds) : [];
};

export const clearSelectedProductIdsForChatbot = () => {
  if (typeof window === 'undefined') return;

  window?.localStorage?.removeItem('CHATBOT_SELECTED_PRODUCT_IDS');
};

export const getChatbotEnv = (): 'dev' | 'prod' | 'staging' => {
  if (typeof window === 'undefined') return 'dev';

  const userID = getCookie('testUserId');

  if (userID && userID === 'chatbot-dev-testing') return 'dev';
  if (userID && userID === 'chatbot-stage-testing') return 'staging';
  if (userID && userID === 'chatbot-prod-testing') return 'prod';
  if (userID && userID === 'product-agent-enabled-dev') return 'dev';
  if (userID && userID === 'product-agent-enabled-staging') return 'staging';

  /** Check if cookie exists */
  const cookieValue = getCookie('chatbot-test');
  if (cookieValue === 'staging') return 'staging';
  if (cookieValue === 'dev' || cookieValue === 'development') return 'dev';
  if (cookieValue === 'prod' || cookieValue === 'production') return 'prod';
  /** For local development */
  const pageURL = window.location.href;
  if (pageURL.includes('localhost')) return 'dev';

  return 'prod';
};

export const getMIAWEnv = (): 'sandbox' | 'production' | 'devs' => {
  if (typeof window === 'undefined') return 'sandbox';
  const pageURL = window.location.href;

  const userID = getCookie('testUserId');

  if (userID && userID === 'chatbot-dev-testing') return 'sandbox';
  if (userID && userID === 'chatbot-stage-testing') return 'sandbox';
  if (userID && userID === 'product-agent-enabled-dev') return 'sandbox';
  if (userID && userID === 'product-agent-enabled-staging') return 'sandbox';

  const cookieValue = getCookie('miaw-test');
  if (cookieValue === 'devs' || cookieValue === 'development') return 'devs';
  if (cookieValue === 'sandbox') return 'sandbox';
  if (cookieValue === 'production') return 'production';
  if (pageURL.includes('localhost')) return 'sandbox';

  return 'production';
};

export const setIsSessionExpired = (sessionId: string, sessionStatus: 'active' | 'expired') => {
  if (typeof window === 'undefined') return;
  window?.localStorage?.setItem(`CHAT_SESSION_STATUS_${sessionId}`, sessionStatus);
};

export const getIsSessionExpired = (sessionId: string) => {
  if (typeof window === 'undefined') return 'active';
  const value = window?.localStorage?.getItem(`CHAT_SESSION_STATUS_${sessionId}`);
  return value ? value : 'active';
};

export const clearIsSessionExpired = (sessionId: string) => {
  if (typeof window === 'undefined') return;
  window?.localStorage?.removeItem(`CHAT_SESSION_STATUS_${sessionId}`);
};

export const clearAllSessionExpiryData = () => {
  if (typeof window === 'undefined') return;
  const keysToRemove = Object.keys(window?.localStorage || {}).filter((key) => key.startsWith('CHAT_SESSION_STATUS_'));
  keysToRemove.forEach((key) => {
    window?.localStorage?.removeItem(key);
  });
};
